import React from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import { Box, Grid, Typography } from '@mui/material'

import { ADMIN_ROLES } from '../../../../core/constants'
import { TextInput, FileUploaderInput } from '../../../../ui'
import { useCombos } from '../../../combos'
import { COMPANY_FORM_CONFIG } from '../../constants'
import { useCompanyProfileContext } from '../../contexts'

export const PublicOfferForm = ({ isPrimaryCompany = false }) => {
  const { company, formState, changeFormState } = useCompanyProfileContext()
  const intl = useIntl()
  const combos = useCombos([])
  const global = useSelector((state) => state.global)
  const isAdmin = ADMIN_ROLES[global.role]
  const inputProps = { formState, onChange: changeFormState, combos, intl }

  const isPrescriptor =
    !!formState?.prescriptor ||
    !!company?.prescriptor ||
    !!global.empresa?.prescriptor ||
    !!global.user?.empresa?.prescriptor ||
    global.role === 'administrador_prescriptor' ||
    formState?.tipo_actividad === '04' ||
    company?.tipo_actividad === '04' ||
    global.empresa?.tipo_actividad === '04'

  return (
    <Box>
      <Typography color="primary" variant={'h6'}>
        Datos de Registro para Oferta Pública
      </Typography>
      <Box mt={2}>
        <Grid container spacing={3}>
          <Grid
            sx={12}
            size={{
              sm: 6,
            }}
          >
            <TextInput
              {...{
                ...COMPANY_FORM_CONFIG(inputProps).RESPONSABLE_LEGAL,
                readOnly: !isAdmin,
              }}
            />
          </Grid>
          <Grid
            sx={12}
            size={{
              sm: 6,
            }}
          >
            <TextInput
              {...{
                ...COMPANY_FORM_CONFIG(inputProps).NIF_RESPONSABLE_LEGAL,
                readOnly: !isAdmin,
              }}
            />
          </Grid>
          {!isPrimaryCompany ? (
            <Grid
              sx={12}
              size={{
                sm: 6,
              }}
            >
              <TextInput
                {...{
                  ...COMPANY_FORM_CONFIG(inputProps).IBAN_OP,
                  readOnly: !isAdmin,
                }}
              />
            </Grid>
          ) : null}
          {!isPrimaryCompany ? (
            <Grid
              sx={12}
              size={{
                sm: 6,
              }}
            >
              <TextInput
                {...{
                  ...COMPANY_FORM_CONFIG(inputProps).SOCIEDAD,
                  readOnly: true,
                }}
              />
            </Grid>
          ) : null}
          {isPrimaryCompany && isPrescriptor ? (
            <>
              <Grid
                sx={12}
                size={{
                  sm: 6,
                }}
              >
                <TextInput
                  {...{
                    ...COMPANY_FORM_CONFIG(inputProps).IBAN_OP,
                    readOnly: !isAdmin,
                  }}
                />
              </Grid>
              <Grid
                sx={12}
                size={{
                  sm: 6,
                }}
              >
                <FileUploaderInput
                  {...{
                    ...COMPANY_FORM_CONFIG(inputProps).CERTIFICADO_BANCARIO_IBAN_SWIFT,
                    readOnly: !isAdmin,
                  }}
                />
              </Grid>
            </>
          ) : null}
          {isPrimaryCompany && !isPrescriptor ? (
            <Grid
              sx={12}
              size={{
                sm: 6,
              }}
            >
              <TextInput
                {...{
                  ...COMPANY_FORM_CONFIG(inputProps).CODIGO_REGISTRO_INDUSTRIAL,
                }}
              />
            </Grid>
          ) : null}
          {!isPrimaryCompany && !isPrescriptor ? (
            <Grid
              sx={12}
              size={{
                sm: 6,
              }}
            >
              <TextInput
                {...{
                  ...COMPANY_FORM_CONFIG(inputProps).CODIGO_REGISTRO_INDUSTRIAL,
                  readOnly: true,
                }}
              />
            </Grid>
          ) : null}
        </Grid>
      </Box>
    </Box>
  )
}
